/**
 * Client helpers for ticket briefing spot-check UI.
 */

export const TICKET_BRIEFING_COLLECTION = 'ticketBriefings';

/**
 * @param {unknown} value
 * @returns {string}
 */
export function formatBriefingUsd(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(n);
}

/**
 * @param {unknown} ms
 * @returns {string}
 */
export function formatWallClock(ms) {
  const n = Number(ms);
  if (!Number.isFinite(n) || n < 0) return '—';
  const hours = n / 3_600_000;
  if (hours < 1) {
    const mins = Math.round(n / 60_000);
    return `${mins}m`;
  }
  if (hours < 48) return `${hours.toFixed(1)}h`;
  return `${(hours / 24).toFixed(1)}d`;
}

/**
 * @param {import('firebase/firestore').Timestamp|Date|null|undefined} ts
 * @returns {string}
 */
export function formatBriefingTimestamp(ts) {
  if (!ts) return '—';
  try {
    const date =
      typeof ts.toDate === 'function'
        ? ts.toDate()
        : ts instanceof Date
          ? ts
          : null;
    if (!date || Number.isNaN(date.getTime())) return '—';
    return date.toLocaleString();
  } catch {
    return '—';
  }
}
